import React from "react";
import { ImageCustomCSS } from "./image-helper";
import classNames from "classnames";

interface ImageProps {
  /**
   * Image source
   */
  imgSrc: string;
  /**
   * Image alt
   */
  alt: string;
  /**
   * Ratio image
   */
  ratio: number;
  /**
   * Extend classnames
   */
  extendClasses?: string;
}

const Image: React.FC<ImageProps> = ({ imgSrc, alt, ratio, extendClasses }) => (
  <div
    className={classNames({
      tfcImage: true,
      [extendClasses as string]: !!extendClasses,
    })}
    style={
      {
        "--image-pb": `${100 / ratio}%`,
        "--background-src": `url(${imgSrc})`,
      } as ImageCustomCSS
    }
  >
    <img
      className="tfcImage-instance"
      src={imgSrc}
      alt={alt}
      loading="lazy"
    />
  </div>
);

export default Image;
